export const levels = [
    { title: "中四及中五常規課程", value: "F45-Regular-24/25" },
    { title: "中六提速課程（2025）", value: "F5-2025" },
    { title: "舊制課程（不建議報讀）", value: "F6-2024" },
] as const;

const levelValues = levels.map((e) => e.value);

export type levelValueType = (typeof levelValues)[number];

export const categories = [
    { title: "必修部分（舊制）", value: "Compulsory-2024" },
    {
        title: "必修部分（新制）",
        value: "Compulsory-2025",
    },
    {
        title: "必修部分（24/25 學年）",
        value: "Compulsory-24/25",
    },
    {
        title: "選修單元 A（舊制）",
        value: "Elective-A-2024",
    },
    {
        title: "選修單元 C（舊制）",
        value: "Elective-C-2024",
    },
    {
        title: "選修單元 D（舊制）",
        value: "Elective-D-2024",
    },
    {
        title: "選修單元 A（新制）",
        value: "Elective-A-2025",
    },
    {
        title: "選修單元 B（新制）",
        value: "Elective-B-2025",
    },
    {
        title: "選修單元 C（新制）",
        value: "Elective-C-2025",
    },
    {
        title: "選修單元 A（24/25 學年）",
        value: "Elective-A-24/25",
    },
    {
        title: "選修單元 B（24/25 學年）",
        value: "Elective-B-24/25",
    },
    {
        title: "選修單元 C（24/25 學年）",
        value: "Elective-C-24/25",
    },
] as const;

const categoryValues = categories.map((e) => e.value);

export type categoryValueType = (typeof categoryValues)[number];

export const disabledLevels: Array<levelValueType> = [];
